import { WhyWeFeedRawRoot } from './WhyWeFeedRaw.styles'
import { Layout } from 'components/Layout'
import { Header } from 'components/Header'
import { useState, useEffect } from 'react'
import { isElementVisible } from 'utils/dom'
import { Footer } from 'components/Footer'
import { Hero } from './components/Hero'
import { DoBetter } from './components/DoBetter'
import { Quote } from './components/Quote'
import { HealthiestFood } from './components/HealthiestFood'
import { StatsSpeak } from './components/StatsSpeak'
import { IsRawSafe } from './components/IsRawSafe'
import { CtaFooter } from 'features/Home/components/CtaFooter'
import { ReviewSlider } from 'features/components/ReviewSlider'

export const WhyWeFeedRaw = () => {
  const header = <Header />
  const [hideCTA, setHideCTA] = useState(true)

  useEffect(() => {
    document.addEventListener('scroll', (e) => {
      if (isElementVisible('a.cta-footer')) {
        setHideCTA(true)
      } else {
        setHideCTA(false)
      }
    })
  }, [])

  return (
    <WhyWeFeedRawRoot>
      <Layout header={header} hideCTA={hideCTA}>
        <Hero />
        <DoBetter />
        <Quote />
        <HealthiestFood />
        <StatsSpeak />
        <IsRawSafe />
        <ReviewSlider color='accent-black' background='tertiary-200' hideCTA />
        <CtaFooter title='why-we-feed-raw:footer.title' />
        <Footer/>
      </Layout>
    </WhyWeFeedRawRoot>
  )
}

WhyWeFeedRaw.displayName = 'WhyWeFeedRaw'
